/**
 * Created by rong on 17/7/12.
 */

// import Utils from '../common/utils';

// const  alySource = Utils.getCookie('source');

const app_version = "11.0.1";
// 直接调用接口
var api = function (_this, type, target, url, params, success, fail) {
  var success = success ? success : function () {
  };
  var apiUrl = _this.$utils.getSpliceHost(target) + url;
  params.app_version = app_version;
  if (type === 'get') {
    var param = {
      params: params
    };
    if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
      param.client_type = 22;
    }
    if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
      param.login_token = window.localStorage.getItem('wxLoginToken');
    }
    if (window.localStorage.getItem('wxToken') && window.localStorage.getItem('wxToken') != 'undefined' && window.localStorage.getItem('wxToken') != 'null') {
      param.token = window.localStorage.getItem('wxToken');
    }
    _this.$http.get(apiUrl, param).then(function (response) {
      if (JSON.parse(response.bodyText).flag === 1) {
        success(JSON.parse(response.bodyText).data)
      } else {
        // if(fail) {
        //   fail(response);
        // } else {
        //   alert(response.data.message)
        // }
        if (response.data.flag === '-641' || response.data.flag == '-615') {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
    })
  } else if (type === 'post') {
    _this.$http.post(apiUrl, params, { emulateJSON: true }).then(function (response) {
      // 响应成功回调
      if (response.data.flag === 1) {
        success(response.data.data)
      } else {
        if (fail) {
          fail(response);
        } else {
          alert(response.data.message)
        }
        if (response.data.flag === '-641' || response.data.flag == '-615') {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        }
      }

    }, function (response) {
      // 响应错误回调
      // alert(response.data.message)
    })
  }
};
// PHP转发接口（V2）
var transmitApiV2 = function (_this, type, target, action, params, success, fail) {
  var success = success ? success : function () {
  };
  var url;
  let host = _this.$utils.getAgentApiHost();
  // if(process.env.NODE_ENV=='local'){
  //   // host = 'http://web-agent.imcoming.com.cn'
  //   host = 'http://web-agent.imcoming.com'
  // }else if(process.env.NODE_ENV=='development'){
  //   host = 'http://web-agent.imcoming.com.cn'
  // }else if(process.env.NODE_ENV=='test'){
  //   host = 'http://web-agent.imcoming.com'
  // }else{
  //   host = 'https://web-agent.anlaiye.com'
  // }
  if (target === 'erp') {
    url = host + '/agent/epost'
  } else if (target === 'public') {
    url = host + '/agent/ppost'
  } else {
    if (type === 'get') {
      url = host + '/agent/get'
    } else {
      url = host + '/agent/postV2'
    }
  }
  // 合并json方法
  var mergeJSON = function (jsonbject1, jsonbject2) {
    var resultJsonObject = {}
    for (var i in jsonbject1) {
      resultJsonObject[i] = jsonbject1[i]
    }
    for (var m in jsonbject2) {
      resultJsonObject[m] = jsonbject2[m]
    }
    return resultJsonObject
  };
  var token = window.localStorage.getItem('wxToken')
  // var token = 'e4a5d084e984e215d38312088d80aaae'
  var paramsMust = {
    app_version: app_version,
    target: target,
    action: encodeURIComponent(action),
    token: token
  };
  if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
    paramsMust.client_type = 22;
  }
  if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
    paramsMust.login_token = window.localStorage.getItem('wxLoginToken');
  }
  var pa = mergeJSON(paramsMust, params)
  if (type === 'get') {

    var apiUrl = url + '?';
    for (var p in pa) {
      if (p === 'target') {
        apiUrl = apiUrl + p + '=' + pa[p]
      } else {
        apiUrl = apiUrl + '&' + p + '=' + pa[p]
      }
    }
    _this.$http.get(apiUrl).then(function (response) {
      if (response.body.flag === 1) {
        success(response.body.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response)
          } else {
            if (response.data.message) {
              alert(response.data.message)
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
      if (response.data.message) {
        alert(response.data.message)
      }
    })
  } else if (type === 'post') {
    _this.$http.post(url, pa, { emulateJSON: true }).then(function (response) {
      if (response.data.result) {
        success(response.data.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response)
          } else {
            if (response.data.flag != '-603') {
              if (response.data.message) {
                alert(response.data.message)
              }
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      if (response.data.message) {
        alert(response.data.message)
      }
      // 响应错误回调
    })
  }
};
// PHP转发接口（V3）
var transmitApiV3 = function (_this, type, target, action, params, success, fail) {
  var success = success ? success : function () {
  };
  var url;
  let host = _this.$utils.getAgentApiHost();
  // if(process.env.NODE_ENV=='local'){
  //   // host = 'http://web-agent.imcoming.com.cn'
  //   host = 'http://web-agent.imcoming.com'
  // }else if(process.env.NODE_ENV=='development'){
  //   host = 'http://web-agent.imcoming.com.cn'
  // }else if(process.env.NODE_ENV=='test'){
  //   host = 'http://web-agent.imcoming.com'
  // }else{
  //   host = 'https://web-agent.anlaiye.com'
  // }
  if (target === 'erp') {
    url = host + '/agent/epost'
  } else if (target === 'public') {
    url = host + '/agent/ppost'
  } else {
    if (type === 'get') {
      url = host + '/agent/get'
    } else {
      url = host + '/agent/postV3'
    }
  }
  // 合并json方法
  var mergeJSON = function (jsonbject1, jsonbject2) {
    var resultJsonObject = {}
    for (var i in jsonbject1) {
      resultJsonObject[i] = jsonbject1[i]
    }
    for (var m in jsonbject2) {
      resultJsonObject[m] = jsonbject2[m]
    }
    return resultJsonObject
  };
  var token = window.localStorage.getItem('wxToken')
  // var token = 'e4a5d084e984e215d38312088d80aaae'
  var paramsMust = {
    app_version: app_version,
    target: target,
    action: encodeURIComponent(action),
    token: token,
    device_id: _this.$store.state.openId
  };
  if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
    paramsMust.client_type = 22;
  }
  if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
    paramsMust.login_token = window.localStorage.getItem('wxLoginToken');
  }
  var pa = mergeJSON(paramsMust, params)
  if (type === 'get') {

    var apiUrl = url + '?';
    for (var p in pa) {
      if (p === 'target') {
        apiUrl = apiUrl + p + '=' + pa[p]
      } else {
        apiUrl = apiUrl + '&' + p + '=' + pa[p]
      }
    }
    _this.$http.get(apiUrl).then(function (response) {
      if (response.body.flag === 1) {
        success(response.body.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response)
          } else {
            if (response.data.message) {
              alert(response.data.message)
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
      if (response.data.message) {
        alert(response.data.message)
      }
    })
  } else if (type === 'post') {
    _this.$http.post(url, pa, { emulateJSON: true }).then(function (response) {
      if (response.data.result) {
        success(response.data.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response)
          } else {
            if (response.data.flag != '-603') {
              if (response.data.message) {
                alert(response.data.message)
              }
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      if (response.data.message) {
        alert(response.data.message)
      }
      // 响应错误回调
    })
  }
};
// PHP转发接口
var transmitApi = function (_this, type, target, action, params, success, fail) {
  var success = success ? success : function () {
  };
  var url;
  let host = _this.$utils.getAgentApiHost();
  if (target === 'erp') {
    url = host + '/agent/epost'
  } else if (target === 'public') {
    url = host + '/agent/ppost'
  } else {
    if (type === 'get') {
      url = host + '/agent/get'
    } else {
      url = host + '/agent/post'
    }
  }
  // 合并json方法
  var mergeJSON = function (jsonbject1, jsonbject2) {
    var resultJsonObject = {}
    for (var i in jsonbject1) {
      resultJsonObject[i] = jsonbject1[i]
    }
    for (var m in jsonbject2) {
      resultJsonObject[m] = jsonbject2[m]
    }
    return resultJsonObject
  };
  let token;
  if (params.token) {
    token = params.token
    delete params.token
  } else {
    token = window.localStorage.getItem('wxToken')
  }
  // var token = window.localStorage.getItem('wxToken')
  // var token = 'e4a5d084e984e215d38312088d80aaae'
  var paramsMust = {
    app_version: app_version,
    target: target,
    action: encodeURIComponent(action),
    token: token,
    // client_type:  11, //云闪付支付调式
    client_type: localStorage.getItem('platformType')
  };
  if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
    paramsMust.client_type = 22;
  }
  if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
    paramsMust.login_token = window.localStorage.getItem('wxLoginToken');
  }
  var pa = mergeJSON(paramsMust, params)
  if (type === 'get') {
    var apiUrl = url + '?target=' + pa.target;
    for (var p in pa) {
      // if(p === 'target') {
      //   apiUrl = apiUrl + p + '=' + pa[p]
      // } else {
      //   apiUrl = apiUrl + '&' + p + '=' + pa[p]
      // }
      if (p != 'target') {
        if (typeof pa[p] === "object") {
          for (var k in pa[p]) {
            // p[k] = pa[p][k]
            apiUrl = apiUrl + '&' + `${p}[${k}]` + '=' + pa[p][k]
          }
        } else {
          apiUrl = apiUrl + '&' + p + '=' + pa[p]
        }
      }
    }
    _this.$http.get(apiUrl).then(function (response) {
      if (response.body.flag === 1) {
        success(response.body.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          _this.$router.push({ name: 'Login' })
          var obj = {
            wxUid: ''
          };
          window.localStorage.removeItem('userDefinedMobile')//退出账号清除自定义自提电话
          window.localStorage.removeItem('cartInfo')//退出账号清除购物车信息
          window.localStorage.removeItem('userInfo')
          window.localStorage.removeItem('wxLoginToken')
          _this.$store.commit('changeState', obj);
        } else {
          if (fail) {
            fail(response)
          } else {
            if (response.data.message) {
              alert(response.data.message)
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
      if (response.data.message) {
        alert(response.data.message)
      }
    })
  } else if (type === 'post') {
    _this.$http.post(url, pa, { emulateJSON: true }).then(function (response) {
      if (response.data.result) {
        if (action === '/v1/public/log/add') {
          success(response)
        } else {
          success(response.data.data)
        }
        // success(response.data.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
          var obj = {
            wxUid: ''
          };
          window.localStorage.removeItem('userDefinedMobile')//退出账号清除自定义自提电话
          window.localStorage.removeItem('cartInfo')//退出账号清除购物车信息
          window.localStorage.removeItem('userInfo')
          window.localStorage.removeItem('wxLoginToken')
          _this.$store.commit('changeState', obj);
        } else {
          if (fail) {
            fail(response)
          } else {
            if (response.data.flag != '-603') {
              if (response.data.message) {
                alert(response.data.message)
              }
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      if (response.data.message) {
        alert(response.data.message)
      }
      // 响应错误回调
    })
  }
};

var actions = {
  // 内部流量统计
  postLogAdd: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'my-order-j', '/v1/public/log/add', params, onSuccess, onFail)
  },
  // 根据选择的学校id,获取学校信息
  postSchoolInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', ' /api/schoolInfo', params, onSuccess, onFail)
  },
  // 获取图形验证码
  postCaptcha: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/web/captcha/get', params, onSuccess, onFail)
  },
  // 发送短信验证码
  postSmsCaptcha: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/sms/webSendCaptcha', params, onSuccess, onFail)
  },
  // 发送短信验证码2
  postAuthCaptcha: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/sms/authCaptcha', params, onSuccess, onFail)
  },
  // 发送短信验证码3
  postSendCaptcha: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/sms/sendCaptcha', params, onSuccess, onFail)
  },
  // 登录注册
  postSignIn: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/signIn', params, onSuccess, onFail)
  },
  // 北大绑定手机号
  postSignInIaaa: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/signInIaaa', params, onSuccess, onFail)
  },
  // 登录
  postSignOut: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/signOut', params, onSuccess, onFail)
  },
  // 登录注册
  postAuthInfo: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/authInfo', params, onSuccess, onFail)
  },
  // 登录注册测试
  postAuth: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/auth', params, onSuccess, onFail)
  },
  // 定位,搜索附近学校列表
  postSchoolSearch: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/search', params, onSuccess, onFail)
  },
  // 获取学校详情
  postSchoolStatus: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/status', params, onSuccess, onFail)
  },
  //获取学校公告
  getNoticeInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/notice/info', params, onSuccess, onFail)
  },
  // 获取首页开关状态
  getHomeStatus: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/school/homeStatus', params, onSuccess, onFail)
  },
  // 获取标签首页列表
  getTagIndexList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/home/index', params, onSuccess, onFail)
  },
  //获取中部幻灯片列表
  getLanternSlide: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/home/slide', params, onSuccess, onFail)
  },
  // 获取店铺分类列表
  postShopCategoryList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/category/list', params, onSuccess, onFail)
  },
  // 获取投诉电话
  getCommercialTel: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/commercial/telInfo', params, onSuccess, onFail)
  },
  // 根据tag获取学校店铺列表
  getTagShopList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/specialList', params, onSuccess, onFail)
  },
  // 根据tag获取标签图片信息
  getTagInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/tags/info', params, onSuccess, onFail)
  },
  // 获取当前学校店铺列表
  getShopList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/listForGoods', params, onSuccess, onFail)
  },
  // 获取当前学校店铺列表
  getShopListNew: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/localMerchants', params, onSuccess, onFail)
  },
  // 获取活动店铺
  getPromtionList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/promotionShop', params, onSuccess, onFail)
  },
  // 获取买过的店
  getBoughtList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/BoughtShop', params, onSuccess, onFail)
  },
  //获取商家权益包
  getBenefitList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/school/benefit/list', params, onSuccess, onFail)
  },
  // 获取店铺标签列表
  getShopTagList: function (_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'goods_center', '/v1/public/app/shop/tag', params, onSuccsee, onFail)
  },
  // 获取店铺信息
  getShopInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/shop/shopLiteInfo', params, onSuccess, onFail)
  },
  // 获取商品列表
  getGoodsList: function (_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'merchants', '/pub/shop/goodsV2', params, onSuccess, onFail)
  },
  // 获取店铺分类列表
  getShopCodeList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'goods_center', '/v1/public/app/shop/code/list', params, onSuccess, onFail)
  },
  // 获取店铺分类列表
  getShopDetailList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'goods_center', '/v1/public/app/shop/gd/page', params, onSuccess, onFail)
  },
  // 获取搜索关键词
  getSearchRecom: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/pub/search/recommend', params, onSuccess, onFail)
  },
  // 获取搜索推荐店铺
  getShopRecom: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/shop/recommend', params, onSuccess, onFail)
  },

  // 获取楼栋列表
  postBuildList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/build/list', params, onSuccess, onFail)
  },
  // 获取可下单楼栋列表
  postBuildLists: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/shopBuild/getBuildList', params, onSuccess, onFail)
  },
  // 获取楼栋列表1
  postBuildList1: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/school/buildlist', params, onSuccess, onFail)
  },
  // 获取店铺楼栋
  postShopBuildList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shopbuild/get', params, onSuccess, onFail)
  },
  // 保存自提地址
  savePickupAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/save', params, onSuccess, onFail)
  },
  // 自提地址详情
  pickupInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/pickup', params, onSuccess, onFail)
  },
  // 订单预检
  postOrderPreview: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/precheck', params, onSuccess, onFail)
  },
  // 提交订单
  postOrderCreate: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/info', params, onSuccess, onFail)
  },
  //获取订单列表
  postOrderList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/mylist', params, onSuccess, onFail)
  },
  // 无人餐厅订单详情
  getOrderDetail_Youxin: function (_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'order_center', '/pub/v1/youXin/order/info', params, onSuccess, onFail)
  },
  //商家获取评论列表
  getBusinessCommentList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/estimate/for/app', params, onSuccess, onFail)
  },
  //获取用户评论页面信息
  getOnlineCommentInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/applyEstimate', params, onSuccess, onFail)
  },
  //用户获取评论列表
  getCommentList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/estimate', params, onSuccess, onFail)
  },
  //用户获取评论详情
  getCommentDetails: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/estimate/detail', params, onSuccess, onFail)
  },
  //用户提交评价
  postSaveComment: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/saveEstimate', params, onSuccess, onFail)
  },
  //删除评论
  getDeleteComment: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/deleteEstimate', params, onSuccess, onFail)
  },
  //点击投诉申请投诉
  getApplyComplaints: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/complaint/apply', params, onSuccess, onFail)
  },
  //用户提交投诉
  postSaveComplaint: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/complaint/add', params, onSuccess, onFail)
  },
  //投诉结果反馈
  postFeedBack: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/submit/resultFeedBack', params, onSuccess, onFail)
  },
  //获取投诉列表
  getComplaintList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/complaint/page', params, onSuccess, onFail)
  },
  //获取投诉详情
  getComplaintDetails: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/complaint/detail', params, onSuccess, onFail)
  },
  //用户取消投诉
  getCancelComplaint: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cancel/complaint', params, onSuccess, onFail)
  },
  //点击申请退款
  getApplyRefund: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/refund/apply', params, onSuccess, onFail)
  },
  //获取退款进度详情
  getRefundDetails: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/refund/detail', params, onSuccess, onFail)
  },
  //同意商家处理结果
  getRefundResult: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/accept/shop/refund', params, onSuccess, onFail)
  },
  //用户申诉操作
  postAppeal: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/handle/appeal', params, onSuccess, onFail)
  },
  //获取优惠券列表
  PostCouponList: function (_this, params, onSuccess, onFail) {
    transmitApiV2(_this, 'post', 'coupon_center', '/pub/user/myCoupon', params, onSuccess, onFail)
  },
  //在线发放优惠券列表
  PostOnlineCouponList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/coupon/grantOnline', params, onSuccess, onFail)
  },
  //领取新优惠券
  receiveCouponNew: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'coupon_center', '/pub/coupon/trigger', params, onSuccess, onFail)
  },
  //领取老优惠券
  receiveCouponOld: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon', '/v1/scenario/grant', params, onSuccess, onFail)
  },
  // 店铺优惠券列表
  shopGrantList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'coupon_center', '/pub/activity/grantlist', params, onSuccess, onFail)
  },
  // 领取店铺优惠券
  receiveShopGrant: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/activity/grant', params, onSuccess, onFail)
  },
  // 一键领取店铺优惠券
  receiveAllShopGrant: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/activity/allgrant', params, onSuccess, onFail)
  },
  // 设置优惠券弹框
  setGrantTotast: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/activity/toast', params, onSuccess, onFail)
  },
  // 兑换优惠券
  redeemCoupon: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'coupon-base', '/web/coupon/redeemCoupon', params, onSuccess, onFail)
  },

  //推荐下单活动banner入口
  recommendBanner: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'star', '/api/recommend/show', params, onSuccess, onFail)
  },
  //新学期优惠券弹框
  showCoupon: function (_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'star', '/api/popbonus/show', params, onSuccess, onFail)
  },
  //模糊匹配学校列表
  postSearchSchool: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/search', params, onSuccess, onFail)
  },
  //全量城市信息列表
  postCityList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/cityListSortByPinyin', params, onSuccess, onFail)
  },
  // 结算接口
  postGetPromotion: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'promotion', '/api/promotion/getPromotion', params, onSuccess, onFail)
  },
  //订单支付方式选择
  getPayWay: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', `/food/order/detail/beforePayment/${params.order_id}`, params, onSuccess, onFail)
  },
  //支付
  postWxJsPay: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/status/paid', params, onSuccess, onFail)
  },
  // H5支付
  h5WxPay: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'payment', '/payment/v1/user/9298055/wx_h5/trans', params, onSuccess, onFail)
  },
  // 校园卡信息
  schoolCardInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/campusCard/get', params, onSuccess, onFail)
  },
  //订单状态
  postOrderStatuslist: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', 'api/order/orderStatuslist', params, onSuccess, onFail)
  },
  //订单详情
  getOrderDetail: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/detail', params, onSuccess, onFail)
  },
  //取消订单
  postCancelOrder: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/cancel', params, onSuccess, onFail)
  },
  //取消订单并退款
  postCancelRefundOrder: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/refund/noduty', params, onSuccess, onFail)
  },
  //确认收货
  postFinalOrder: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/confirmReceived', params, onSuccess, onFail)
  },
  // 一键开柜
  openCabinet: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/take/food', params, onSuccess, onFail)
  },
  // 催单
  reminderOrder: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/reminder', params, onSuccess, onFail)
  },
  //客服信息
  managerInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/api/manager/info', params, onSuccess, onFail)
  },

  // 获取商品分类列表
  postCategoryList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'erp', '/v1/public/category/list', params, onSuccess, onFail)
  },

  // 获取商品详情
  postGoodsDetail: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'erp', '/v1/public/goods_center/detail', params, onSuccess, onFail)
  },
  // 搜索商品列表
  postGoodsSearch: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'erp', '/v1/public/school/goods_center/search', params, onSuccess, onFail)
  },
  // 热门商品列表
  postGoodsSearchHost: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport', '/api/supermarket/searchhot', params, onSuccess, onFail)
  },
  // 商品搜索
  getGoodsSearch: function (_this, params, onSuccess, onFail) {
    // merchants / goods
    transmitApi(_this, 'get', 'merchants', '/pub/shop/search', params, onSuccess, onFail)
  },


  // 获取用户默认地址
  postDefaultAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/default', params, onSuccess, onFail)
  },
  // 获取地址列表
  postAddressList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/list', params, onSuccess, onFail)
  },
  // 设置默认地址
  postSetDefaultAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/setdefault', params, onSuccess, onFail)
  },
  // 新增收货地址
  postAddAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport', '/api/address/createUserAddress', params, onSuccess, onFail)
  },
  // 获取收货地址详情
  postUserAddressInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/address/detail', params, onSuccess, onFail)
  },
  // 编辑收货地址
  postEditAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport', '/api/address/editUserAddress', params, onSuccess, onFail)
  },
  // 保存收货地址
  postSaveAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/address/save', params, onSuccess, onFail)
  },
  // 删除收货地址
  postDeleteAddress: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/address/remove', params, onSuccess, onFail)
  },
  // 判断是否为商家配送
  getJudgeShopDelivery: function (_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'transport_center', '/transport/app/judge/shopDelivery', params, onSuccsee, onFail)
  },
  // 用户获取配送单详情
  getTransportInfo: function (_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'transport_center', '/transport/app/customer/transportInfo', params, onSuccsee, onFail)
  },
  // 用户查询配送进程状态记录
  getProgressLog: function (_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'transport_center', '/transport/app/customer/progress/log', params, onSuccsee, onFail)
  },
  //红包分享接口
  getredPacketShare: function (_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/redPacket/detail', params, onSuccsee, onFail)
  },

  // 云柜相关

  postSignInByMujia: function (_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/authByBusiness', params, onSuccess, onFail)
  },
  // 查询免密状态
  postContractInfoByMujia: function (_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'passport_v3', '/priv/payment/contractInfo', params, onSuccess, onFail)
  },
  // 订单
  getOrderListByMujia: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cloudArk/order/list', params, onSuccess, onFail)
  },
  // 开门后查订单
  getPaidDetailByMujia: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cloudArk/order/paidDetail', params, onSuccess, onFail)
  },
  // 订单预检
  getOrderPreviewByMujia: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cloudArk/order/precheck', params, onSuccess, onFail)
  },
  // 开启免密支付
  getEntrustWebByMujia: function (_this, params, onSuccess, onFail) {
    api(_this, 'get', 'payment', '/pub/provider/wx/entrustweb', params, onSuccess, onFail)
  },
  // 开柜
  getTerminalOpenByMujia: function (_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'passport_v3', '/pub/terminal/open', params, onSuccess, onFail)
  },
  // 调起免密支付
  postWeixinEntrustByMujia: function (_this, params, onSuccess, onFail) {
    api(_this, 'get', 'oc', '/food/trade/pay/wx_entrust/h5', params, onSuccess, onFail)
  },
  // 打赏西游侠信息
  getWeixinRewardInfo: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/reward/detail', params, onSuccess, onFail)
  },
  // 打赏西游侠列表
  getWeixinRewardList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/reward/order/list', params, onSuccess, onFail)
  },
  // 查询核销状态
  getOrderStatus: function (_this, params, onSuccess, onFail) {
    api(_this, 'get', 'oc', '/admin/order/status', params, onSuccess, onFail)
  },
  // 哆啦宝
  getOrderPaywayStatus: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/order/payway/status', params, onSuccess, onFail)
  },
  // 我的西游积分
  getMyScore: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getScore', params, onSuccess, onFail)
  },
  getScoreList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getEventList', params, onSuccess, onFail)
  },
  getScoreDetail: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/detail', params, onSuccess, onFail)
  },
  userSign: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/sign/userSign', params, onSuccess, onFail)
  },
  getUserSignList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/sign/userSignList', params, onSuccess, onFail)
  },
  getScoreListNew: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getEventListNew', params, onSuccess, onFail)
  },
  //点击广告得积分
  scoreClickAd: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/score/clickAd', params, onSuccess, onFail)
  },
  // 会员等级
  getLevel: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getLevel', params, onSuccess, onFail)
  },
  // 经验说明
  getExpDesc: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/level', params, onSuccess, onFail)
  },
  addLog: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'my-order-j', '/v1/public/log/add', params, onSuccess, onFail)
  },
  // 优信订单详情
  youxinOrderList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/pub/v1/youXin/order/info', params, onSuccess, onFail)
  },
  // 券包列表
  postPackageList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'promotion', '/pub/package/get', params, onSuccess, onFail)
  },
  // 券包可用店铺列表
  postPackageShop: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/package/shop', params, onSuccess, onFail)
  },
  // 券包购买
  postPackagePurchaseRecord: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'promotion', '/pub/package/packagePurchaseRecord', params, onSuccess, onFail)
  },
  // 新学期红包
  postPopBonusShow: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/pub/popBonus/show', params, onSuccess, onFail)
  },
  // 店铺 获取标签下的code列表
  postShopCodeList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'gc', '/v1/public/app/shop/code/list', params, onSuccess, onFail)
  },
  postShopGdList: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'gc', '/v1/public/app/shop/gd/page', params, onSuccess, onFail)
  },
  // 幸福星期天
  getHappySundayShow: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'promotion', '/pub/happy/show', params, onSuccess, onFail)
  },
  // 下单返券
  getOrderCoupon: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'promotion', '/pub/order/coupon', params, onSuccess, onFail)
  },
  // 下单返券
  getOrderCard: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'star', '/api/cardPlus/orderCard', params, onSuccess, onFail)
  },
  // 下单预计得积分
  getScorePartake: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/api/score/partake',params, onSuccess, onFail)
  },
  // 常驻活动入口
  postCardPlus: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/api/cardPlus/appCard', params, onSuccess, onFail)
  },
  // 切换学校
  toggleSchool: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/userinfo/toggleSchool', params, onSuccess, onFail)
  },
  // clc 邀请有礼
  clcAcceptInvite: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/api/clc/acceptInvite', params, onSuccess, onFail)
  },
  // 订单获取立减金
  getOrderBonus: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/api/weekend/getOrderBonus', params, onSuccess, onFail)
  },
  // 保单详情
  getPunctualOrderDetail: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/punctual/order/detail', params, onSuccess, onFail)
  },
  // 准时达
  getUserInfoFullByUid: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/userinfo/fullbyuid', params, onSuccess, onFail)
  },
  setUserSignContract: function (_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/userinfo/signContract', params, onSuccess, onFail)
  },
  //获取微信相关信息
  getJslbsConf: function (_this, url, onSuccess) {
    let host = _this.$utils.getAgentApiHost(),
      str;
    if (process.env.NODE_ENV == 'local' || process.env.NODE_ENV == 'development') {
      host = host + '/wechatDev'
    } else {
      host = host + '/wechat'
    }
    // 解决安卓和ios兼容问题
    str = url;
    if (!_this.$utils.isAndroid()) {
      str = encodeURIComponent(window.localStorage.getItem('upSDKUrl'))
    }
    _this.$http.get(host + '/Jssdk/lbsConf?url=' + str).then(function (redata) {
      var wxInfo = JSON.parse(redata.bodyText);
      if (wxInfo.flag == -1) {
        // alert(wxInfo.message);
        return;
      }
      onSuccess(wxInfo.data)
    }, function (redata) {
      if (redata.body.message) {
        // alert(redata.body.message);
      }
    })
  },
  //获取微信相关信息
  getJsShareConf: function (_this, url, onSuccess) {
    let host = _this.$utils.getAgentApiHost();
    if (process.env.NODE_ENV == 'local' || process.env.NODE_ENV == 'development') {
      host = host + '/wechatDev'
    } else {
      host = host + '/wechat'
    }
    _this.$http.get(host + '/Jssdk/shareconf?url=' + url).then(function (redata) {
      //var wxInfo = JSON.parse(redata.bodyText);
      if (redata.flag == -1) {
        // alert(redata.message);
        return;
      }
      onSuccess(redata.data)
    }, function (redata) {
      if (redata.message) {
        // alert(redata.message);
      }
    })
  },
  // 扫码
  getJsScanQRCodeConf: function (_this, url, onSuccess) {
    let host = _this.$utils.getAgentApiHost() + '/wechat'
    // let host = '';
    // if(process.env.NODE_ENV=='local'){
    //   host = 'http://web-agent.imcoming.com.cn/wechat'
    // }else if(process.env.NODE_ENV=='development'){
    //   host = 'http://web-agent.imcoming.com.cn/wechat'
    // }else if(process.env.NODE_ENV=='test'){
    //   host = 'http://web-agent.imcoming.com/wechat'
    // }else{
    //   host = 'https://web-agent.anlaiye.com/wechat'
    // }
    //var url = 'http://alywechat.imcoming.com/?school_lock=false';
    _this.$http.get(host + '/Jssdk/qrScanConf?url=' + url).then(function (redata) {
      //var wxInfo = JSON.parse(redata.bodyText);
      if (redata.flag == -1) {
        // alert(redata.message);
        return;
      }
      onSuccess(redata.data)
    }, function (redata) {
      if (redata.message) {
        // alert(redata.message);
      }
    })
  }
};

module.exports = {
  actions: actions
};




// WEBPACK FOOTER //
// ./src/store/actions.js